import { Component, Input} from '@angular/core';
import { NbDialogRef, NbDialogService, NbThemeService } from '@nebular/theme';
import { ApiService } from './../../../../shared/api.service';
import { NbAuthService, NbAuthJWTToken } from '@nebular/auth';
import { config } from './../../../../../../config';
import {ConfirmationService} from 'primeng/api';
import { previewImg } from './transcriptpreview.component';
@Component({
selector: 'nb-dialog',
template: `
<style>
.viewMoreImg{
  width: 117px;
  height: 124px;
  /* margin-left: auto;
  margin-right: auto;
  border: 1px solid #c4c4c4;*/
  display: block;
}
</style>
<nb-card *ngIf="component_no==0" [nbSpinner]="loading" nbSpinnerStatus="danger" nbSpinnerSize="xlarge">
  <nb-card-header>Add Reason</nb-card-header>
  <nb-card-body>
    <div class="row">
     <!-- <div class="col-xl-12" style='center;'>
        <b>Input the name of college where you are seeking admission :</b>
        <input type="text" class="form-control" (input)="onSearchChange($event.target.value)" [(ngModel)]="reason" name='inputTranscriptName' id="inputTranscriptName" placeholder="Reason">
      </div><br><br><br>
      <div class="col-xl-12" *ngIf="errorMessage == true">
        <span style="color:red; font-size: large;">Please add the name of college.</span>
      </div>
      <br> -->
      <div class="col-xl-12">
      <br>
      <p style="color:red; font-weight: bold;" >Notes:</p>
      <span>
      कृपया खात्री करा की तुमच्या हस्तांतरण प्रमाणपत्रावर तारीख नमूद केली आहे.<br> हे देखील लक्षात ठेवा की त्यावर महाविद्यालयीन अधिकाऱ्यांनी शिक्का आणि स्वाक्षरी केलेली असावी.
      <br> जर ते नमूद केल्याप्रमाणे असेल तर तुम्ही तुमच्या अर्जासह पुढे जाण्यासाठी क्लिक करू शकता.
      <br>एकतर तारखेचा उल्लेख नसल्यास किंवा त्यावर शिक्का आणि स्वाक्षरी नसल्यास,
      <br> त्यानंतर CANCEL वर क्लिक करा आणि DATE, STAMP आणि SIGN अपडेट करण्यासाठी तुमच्या कॉलेजशी संपर्क साधा
      </span>
      <br>
      <br>
      <p style="font-weight: bold;">हस्तांतरण प्रमाणपत्राचे पूर्वावलोकन:      </p>
      <img src="{{imageUrl}}/api/upload/profile_pic/tc_formate.png" nbPopover="Click here to download the document" nbPopoverMode="hover" style="height:117px; width:124px;" (click)="onView(Transfer?.sample_filename,Transfer?.sample_type)">
      <br><br><span style="margin: 2px 11px 1px 1px; font-size: 15px; font-weight: bold;">I have read and agree to the <span style="color:blue;">Notes</span></span><nb-checkbox  (click)="accept($event)" [value]="checked" ></nb-checkbox>
        <span *ngIf='uploaderror == true' style="color:red; font-size: large;">Max uploaded file size should be 5 MB.</span>
      </div>
    </div>
  </nb-card-body>
  <nb-card-footer>
    <button nbButton style="margin: 0px 19px 21px 4px;" hero status="primary" (click)="dismiss()">Close</button>
    <p-fileUpload  *ngIf="showUpload1 == true"  ngDefaultControl [accept]="'.pdf,.PDF'" mode="basic" auto="true"
          chooseLabel="Upload" name="file" url="{{transUploadUrl}}?user_id={{user_id}}&&transcript_name=Transfer Certificate&&hiddentype=User_Marsheet"
          maxFileSize="5000000"
          (onBeforeSend)="onBeforeSend($event)"
          (onUpload)="onUpload($event)"
          (onSelect)="onSelect($event)"
           
          (onError)="onErrorFileUpload($event)">
        </p-fileUpload>
  </nb-card-footer>
</nb-card>
<nb-card *ngIf="component_no==2" [nbSpinner]="loading" nbSpinnerStatus="danger" nbSpinnerSize="xlarge">
  <nb-card-header>Confirmation</nb-card-header>
  <nb-card-body>
      <p style="color:red; font-weight: bold;" >Notes:</p>
    <p>Kindly ensure the PRN Status Report does mention your PRN Number. <br>The Eligibility Status should show "ELIGIBLE". <br>In case it shows as "PROVISIONALLY ELIGIBLE" then kindly contact your college.<br> Also note it should be stamped & signed by the college authorities.<br> In case it is as mentioned then you can click to proceed with your application.<br> In case it is either provisionally eligible OR its not stamped & signed,<br> then click CANCEL & contact your college to update STAMP & SIGN on the certificate</p>
    <br>
    <p style="font-weight: bold;">Preview Of PRN Status Report: </p>
    <img class="viewMoreImg" src="{{PRN_Status_Report?.sample_filename}}"  nbPopover="Click here to view the document" nbPopoverMode="hover" (click)="onView(PRN_Status_Report?.sample_filename,PRN_Status_Report?.sample_type)"/>
    <br>
    <span style="margin: 2px 11px 1px 1px; font-size: 15px; font-weight: bold;">मी नोट्स वाचल्या आहेत आणि त्यांच्याशी सहमत आहे <span style="color:blue;"></span></span><nb-checkbox  (click)="acceptPRN($event)" [value]="checked" ></nb-checkbox>
    <span *ngIf='uploaderror == true' style="color:red; font-size: large;">Max uploaded file size should be 5 MB.</span>
    </nb-card-body>
  <nb-card-footer>
    <button nbButton hero  style="margin: 0px 19px 21px 4px;" status="primary" (click)="dismiss()">Close</button>
        <p-fileUpload class="file_upload" *ngIf="showUpload1 == true" ngDefaultControl [accept]="'.jpg,.jpeg,.png,.pdf,.PNG,.JPEG,.JPG,.PDF'" mode="basic" auto="true"
        chooseLabel="Upload" name="file" url="{{transUploadUrl}}?user_id={{user_id}}&&transcript_name=PRN Status Report&&hiddentype=User_Document"
        maxFileSize="5000000"
        (onBeforeSend)="onBeforeSend($event,'14')"
        (onUpload)="onUpload($event,'14')"
        (onSelect)="onSelect($event)"
        (onError)="onErrorFileUpload($event,'14')">
      </p-fileUpload>
  </nb-card-footer>
</nb-card>
`,
providers:[ConfirmationService],
})
export class TranscriptDialogComponent {
@Input() title: string;
@Input() user_id: any;
@Input() component_no: any;
cbse_marks;
currenttoken;
showUpload;
loading = false;
user = { name : "", id:""};
reason;
imageUrl = config.imageUrl;
uploaderror = false;
uploaderror1 = false;
transUploadUrl = config.docUploadUrl;
checked=false;
errorMessage = false;
showUpload1;
PRN_Status_Report:any;
Transfer:any;
checked_value:false;

constructor(
  protected ref: NbDialogRef<TranscriptDialogComponent>,
  protected api : ApiService,
  private authService: NbAuthService,
  public themeService : NbThemeService,
  private confirmationService: ConfirmationService,
  private dialogService: NbDialogService,
  )
  {

  }

  dismiss() {
  this.ref.close();
  }

  onBeforeSend(event) {
    this.loading = true;
    this.authService.onTokenChange().subscribe((token: NbAuthJWTToken) => {
      if (token.isValid()) {
       this.currenttoken = token;
        event.xhr.setRequestHeader("Authorization", `Bearer ` +this.currenttoken);
        event.formData.append('token',''+this.currenttoken);
        }
    });
  }

  onUpload(event) {
      const reader = new FileReader();
      if(event.files && event.files.length) {
        const [file] = event.files;
        reader.readAsDataURL(file);
        this.loading = false;
        this.ref.close(file);
      }

  }

  selectedFile: File;

  onSelect($event: any): void {
		var maxFileSize =  5000000;
		var imgArr = $event.files[0].name.split('.');
    var extension = imgArr[imgArr.length - 1].trim();

    if(extension!='jpg' && extension!='jpeg' && extension!='png' && extension!='pdf'){
			this.uploaderror1 = true;
    }

    if ($event.files[0].size > maxFileSize) {
      this.uploaderror = true;
      this.confirmationService.confirm({
				message: 'Maximum file size should be 5 MB.',
				header: 'Invalid File Size',
				icon: 'pi pi-info-circle',
				rejectVisible : false,
				acceptLabel: 'Ok'
			});
    }


  }


  ngOnInit() {
     this.api.getTheme().subscribe((data: any) => {
        if(data['data']){
          this.themeService.changeTheme(data['data']);
        }else{
          this.themeService.changeTheme('default');
        }
      });
      this.api.getApplicantFiles(this.user_id).subscribe(data =>{
        this.PRN_Status_Report = data['data']['PRN_Status_Report'];
        this.Transfer = data['data']['Transfer'];
      })

   }
   onView(imagename,imgType){
    // console.log("imgType== "+imgType)
     this.dialogService.open(previewImg, {
       context: {
       arr : imagename,
       imgType : imgType
       },
     });
   }
   onSearchChange(searchValue : string ) {
     this.showUpload1=false;
     this.errorMessage = false;
     if(searchValue == "" || searchValue == " " || searchValue == "  " || searchValue == "   " || searchValue == "    " || searchValue == "     " || searchValue == "      " || searchValue == "       " || searchValue == "        " || searchValue == "         " || searchValue == "          " || searchValue == "           " || searchValue == "            " || searchValue == "             " || searchValue == "              " || searchValue == "               " || searchValue == "                " || searchValue == "                 " || searchValue == "                  " || searchValue == "                   " || searchValue == "                    " || searchValue == "                     " || searchValue == "                      " ){
      this.errorMessage = true;
      this.showUpload = false;
     }else{
      this.showUpload = true;
       if(this.checked_value){
        this.showUpload1=true;
        this.checked=true;
       }else{
        this.showUpload1=false;
        this.checked=false;
       }
     }

  }

  accept($event){
    this.checked_value = $event.target.checked;
    // var text = this.reason;
    // var result = text.trim();
    // if(result == ''){
      // this.errorMessage = true;
      // this.checked_value == false;
    // }else{
      if($event.target.checked ==true){
        this.showUpload1=true;
      }else{
        this.showUpload1=false;
      }
    // }
  }

  acceptPRN($event){
    if($event.target.checked ==true){
      this.showUpload1=true;
    }else{
      this.showUpload1=false;
    }
  }

}
